/* eslint-disable no-console */
import api from '../api';
import * as Types from '../types';

/**
 * Get remote working administrator configuration
 *
 * @async
 * @return {Promise<Types.Configuration>} Response from API under Axios instance
 */
export const getConfiguration = async () => {
  const result = await api.get('/configuration');

  try {
    await Types.configurationSchema.validateAsync(result.data);
  } catch (error) {
    console.error(error);
    throw Error(`getConfiguration result do not validate configurationSchema : ${error}`);
  }

  return result.data;
};

/**
 * Update remote working administrator configuration
 *
 * @async
 * @param {Types.Configuration} data
 * @return {Promise} Response from API under Axios instance
 */
export const patchConfiguration = (data) => api.patch('/configuration', data);
